// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"64816b97","453":"539ffe16","455":"c7765d35","977":"47ec16e0"}[chunkId] + ".chunk.js";
};